<span>
  <!-- What is PlaceNameID ? location.PlaceName -->
  <span *ngIf="location.PlaceName !== null && location.PlaceName !== ''">
    <strong>{{ location.PlaceName }}</strong>
  </span>
  <span>
    {{ location.Address | fullAddressFilter : false }}
  </span>
</span>
